import { SavingThrowsTable, classForSavingThrows } from '../constants/savingthrows.js';

function getSavingThrows ( characterClass, level ) {

    let newSavingThrows = {};
        if (!characterClass.includes('/')) {
          const saveClass = classForSavingThrows[characterClass];
          console.log('saving throw class: ', saveClass, " level: ", level);
          newSavingThrows = SavingThrowsTable.find(
            entry => entry.class === saveClass && entry.level === parseInt(level)
          );

        } else { // multi-class case

          const classesArray = characterClass.split('/')
          console.log(classesArray)
          // iterate through classesArray, look up each in classForSavingThrows, use that to get the saving throws for this class
          // then, for each saving throw, take the minimum value across all of the class saving throws

          // Initialize saving throws with very high values to find the minimum
          newSavingThrows['poison'] = Infinity;
          newSavingThrows['poly'] = Infinity;
          newSavingThrows['wand'] = Infinity;
          newSavingThrows['breath'] = Infinity;
          newSavingThrows['magic'] = Infinity;

          // Iterate through each class in the multi-class array
          classesArray.forEach(cls => {
            const saveClass = classForSavingThrows[cls];

            // Find the saving throws for this class and level
            const classSavingThrows = SavingThrowsTable.find(
              entry => entry.class === saveClass && entry.level === parseInt(level)
            );

            console.log(cls, classSavingThrows)

            if (classSavingThrows) {
              // Update saving throws to the minimum value across all classes
              newSavingThrows['poison'] = Math.min(newSavingThrows['poison'], classSavingThrows['poison']);
              newSavingThrows['poly'] = Math.min(newSavingThrows['poly'], classSavingThrows['poly']);
              newSavingThrows['wand'] = Math.min(newSavingThrows['wand'], classSavingThrows['wand']);
              newSavingThrows['breath'] = Math.min(newSavingThrows['breath'], classSavingThrows['breath']);
              newSavingThrows['magic'] = Math.min(newSavingThrows['magic'], classSavingThrows['magic']);
            }
        });

        console.log('Final multi-class saving throws:', newSavingThrows);

        /* don't change anything
          newSavingThrows['poison'] = newCharData.saves['mySav1'];
          newSavingThrows['poly'] = newCharData.saves['mySav2'];
          newSavingThrows['wand'] = newCharData.saves['mySav3'];
          newSavingThrows['breath'] = newCharData.saves['mySav5'];
          newSavingThrows['magic'] = newCharData.saves['mySav4'];
        */

        }

    return newSavingThrows

}

export default getSavingThrows